import FormBuilderConfig from "../../../toolkit/baseForms2/formBuilder/FormBuilder.config";
import IButtonBuilder from "../../../toolkit/baseForms2/iButtonBuilder/IButtonBuilder";
import IUserSelectorBuilder from "../../../toolkit/baseForms2Commons/iUserSelectorBuilder/IUserSelectorBuilder";
import IDateBuilder from "../../../toolkit/baseForms2/iDateBuilder/IDateBuilder";
import ITextBuilder from "../../../toolkit/baseForms2/iTextBuilder/ITextBuilder";
import { userHasPermission } from "../../../utils/accessTree";
import ISelectBuilder from "../../../toolkit/baseForms2/iSelectBuilder/ISelectBuilder";
import permissionCodes from "../../../utils/permissionCodes";

const {
  COMISIONES_V2_ACTUALIZAR_EMPLEADO_IGNORAR_PUESTO: IGNORAR_PUESTO
} = permissionCodes;

export type Inputs =
  | "idEmpleado"
  | "titleSugerida"
  | "fechaSugerida"
  | "horaSugerida"
  | "ignorarPuesto"
  | "razonIgnorarPuesto";
export type Buttons = "aceptar" | "cancelar";

export const formConfigInstructor: FormBuilderConfig<Inputs, Buttons> = {
  inputs: [
    {
      name: "idEmpleado",
      label: "* Instructor",
      bts: {
        mCol: 12
      },
      component: IUserSelectorBuilder
    },
    {
      name: "ignorarPuesto",
      label: "Ignorar puesto de trabajo",
      bts: {
        mCol: 12
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "No",
        data: [{ value: "true", label: "Si" }],
        hidden: () => !userHasPermission(IGNORAR_PUESTO)
      }
    },
    {
      name: "razonIgnorarPuesto",
      label: "Razón",
      bts: {
        mCol: 12
      },
      component: ISelectBuilder,
      props: {
        emptyLabel: "Seleccione una opción",
        data: [
          {
            value: "Personal no cubierto en el puesto",
            label: "Personal no cubierto en el puesto"
          },
          {
            value: "Baja inesperada de colaborador(a)",
            label: "Baja inesperada de colaborador(a)"
          },
          {
            value: "Excepción aceptada por T. y C.",
            label: "Excepción aceptada por T. y C."
          }
        ],
        hidden: () => !userHasPermission(IGNORAR_PUESTO),
        disabled: formValue => formValue.ignorarPuesto !== "true"
      }
    },
    {
      name: "titleSugerida",
      label: "Info de la hora"
    },
    {
      name: "fechaSugerida",
      label: "Fecha Sugerida",
      bts: {
        mCol: 6
      },
      component: IDateBuilder,
      props: {
        hidden: formValue => !formValue.fechaSugerida && !formValue.horaSugerida
      }
    },
    {
      name: "horaSugerida",
      label: "Hora sugerida",
      bts: {
        mCol: 6
      },
      component: ISelectBuilder,
      props: {
        hidden: formValue =>
          !formValue.fechaSugerida && !formValue.horaSugerida,
        data: [
          { value: "05:00", label: "05:00 AM" },
          { value: "05:30", label: "05:30 AM" },
          { value: "06:00", label: "06:00 AM" },
          { value: "06:30", label: "06:30 AM" },
          { value: "07:00", label: "07:00 AM" },
          { value: "07:30", label: "07:30 AM" },
          { value: "08:00", label: "08:00 AM" },
          { value: "08:30", label: "08:30 AM" },
          { value: "09:00", label: "09:00 AM" },
          { value: "09:30", label: "09:30 AM" },
          { value: "10:00", label: "10:00 AM" },
          { value: "10:30", label: "10:30 AM" },
          { value: "11:00", label: "11:00 AM" },
          { value: "11:30", label: "11:30 AM" },
          { value: "12:00", label: "12:00 PM" },
          { value: "12:30", label: "12:30 PM" },
          { value: "13:00", label: "01:00 PM" },
          { value: "13:30", label: "01:30 PM" },
          { value: "14:00", label: "02:00 PM" },
          { value: "14:30", label: "02:30 PM" },
          { value: "15:00", label: "03:00 PM" },
          { value: "15:30", label: "03:30 PM" },
          { value: "16:00", label: "04:00 PM" },
          { value: "16:30", label: "04:30 PM" },
          { value: "17:00", label: "05:00 PM" },
          { value: "17:30", label: "05:30 PM" },
          { value: "18:00", label: "06:00 PM" },
          { value: "18:30", label: "06:30 PM" },
          { value: "19:00", label: "07:00 PM" },
          { value: "19:30", label: "07:30 PM" },
          { value: "20:00", label: "08:00 PM" },
          { value: "20:30", label: "08:30 PM" },
          { value: "21:00", label: "09:00 PM" },
          { value: "21:30", label: "09:30 PM" },
          { value: "22:00", label: "10:00 PM" },
          { value: "22:30", label: "10:30 PM" },
          { value: "23:00", label: "11:00 PM" },
          { value: "23:30", label: "11:30 PM" }
        ]
      }
    }
  ],
  buttons: [
    {
      name: "aceptar",
      label: "Aceptar",
      component: IButtonBuilder,
      isSubmit: true,
      bts: {
        mOff: 4,
        mCol: 4
      },
      props: {
        color: "primary",
        type: "submit"
      }
    },
    {
      name: "cancelar",
      label: "Cancelar",
      component: IButtonBuilder,
      bts: {
        mCol: 4
      },
      props: {
        color: "secondary"
      }
    }
  ],
  validations: {
    idEmpleado: {
      required: true
    },
    razonIgnorarPuesto: {
      requiredIfIgnorarPuesto: {
        validator: (value, formValue) =>
          formValue.ignorarPuesto === "true" && !value,
        message: () => "Campo obligatorio"
      }
    }
  },
  rows: [
    ["idEmpleado"],
    ["ignorarPuesto", "razonIgnorarPuesto"],
    ["titleSugerida", "fechaSugerida", "horaSugerida"],
    ["aceptar", "cancelar"]
  ]
};
